import script from "./announcementView.vue?vue&type=script&setup=true&lang=js"
export * from "./announcementView.vue?vue&type=script&setup=true&lang=js"

import "./announcementView.vue?vue&type=style&index=0&id=3b62bece&lang=less&scoped=true"

import exportComponent from "/data/jenkins/workspace/DLJY-Web-Test/example/main/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3b62bece"]])

export default __exports__